import { render, staticRenderFns } from "./SelectDocumentTypeForm.vue?vue&type=template&id=059ff1c4&"
import script from "./SelectDocumentTypeForm.vue?vue&type=script&lang=js&"
export * from "./SelectDocumentTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports